import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Address, CxDatePipe, TranslationService, User } from '@spartacus/core'
import { Card } from '@spartacus/storefront'
import { Observable, combineLatest } from 'rxjs'
import { filter, map } from 'rxjs/operators'
import { IAgreement } from '../../../../../../models/interface/agreement.interface'
import { IShipment } from '../../../../../../models/interface/shipment.interface'

@Component({
    selector: 'app-order-placed',
    templateUrl: './dispenser-order-placed.component.html',
    styleUrls: ['./dispenser-order-placed.component.scss'],
    standalone: false
})
export class DispenserOrderPlacedComponent implements OnInit {
  @Input() quantityOrdered: number
  @Input() isCreditNoteRequest: boolean
  @Input() user: User
  @Input() agreement: IAgreement
  @Input() shipment: IShipment
  @Input() finalFormattedAddress: string

  @Output() eventBack = new EventEmitter<void>()

  constructor(
    protected translation: TranslationService,
    private datePipe: CxDatePipe
  ) {}

  ngOnInit(): void {}

  public getRequestedDeliveryDate(requestedDeliveryDate: string): Observable<Card> {
    return combineLatest([
      this.translation.translate('checkoutShipping.requestedDeliveryDate'),
      this.translation.translate('shared.none')
    ]).pipe(
      map(([textTitle, noneTextTitle]) => {
        return {
          title: textTitle,
          text: [requestedDeliveryDate ? this.datePipe.transform(requestedDeliveryDate, 'longDate') : noneTextTitle]
        }
      })
    )
  }

  public getPurchaseOrderNumber(poNumber: string): Observable<Card> {
    return combineLatest([
      this.translation.translate('dispenserAgreement.purchaseOrderNumber'),
      this.translation.translate('shared.none')
    ]).pipe(
      map(([textTitle, noneTextTitle]) => ({
        title: textTitle,
        text: [poNumber ? poNumber : noneTextTitle]
      }))
    )
  }

  public getAddressCardContent(deliveryAddress: Address): Observable<Card> {
    return this.translation.translate('addressCard.shipTo').pipe(
      filter(() => Boolean(deliveryAddress)),
      map((textTitle) => {
        const formattedAddress = this.normalizeFormattedAddress(deliveryAddress.formattedAddress)

        return {
          title: textTitle,
          text: [formattedAddress, deliveryAddress.country?.name]
        }
      })
    )
  }

  private normalizeFormattedAddress(formattedAddress: string): string {
    const addresses = formattedAddress.split(',').map((address) => address.trim())

    const newFormattedAddress = addresses.filter(Boolean).join(', ')
    return newFormattedAddress
  }
}
